import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <path d="M19 7h-14c-1.1 0-2 .9-2 2v10.5c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-10.5c0-1.1-.9-2-2-2zm0 1c1.33 0 1.33 2 0 2c-1.33 0 -1.33 -2 0 -2zm0 10.5c1.33 0 1.33 2 0 2c-1.33 0 -1.33 -2 0 -2zm-14 0c1.33 0 1.33 2 0 2c-1.33 0 -1.33 -2 0 -2zm0 -10.5c1.33 0 1.33 2 0 2c-1.33 0 -1.33 -2 0 -2zM19 2.5c.5 0 1 .5 1 1v1c0 .5-.5 1 -1 1h-10c-1.5 0-1.5-2 0-2z" />,
  "Servo"
);
